import React, { useEffect }from 'react'
import "./Subscribe.css"
import { TiSocialGooglePlus } from "react-icons/ti"
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Subscribe = () => {
    useEffect(() => {
        AOS.init({
           duration: 1000, 
        }); 
    }, []) 
    return (
        <section id='subscribe' data-aos="fade-up">
            <div className='container subscribe'>
                <h2>Subscribe now!</h2>
                <form>
                    <div className='form-control'>
                        <input type="text" placeholder='Enter Your Email...' />
                        <button>Subscribe</button>
                    </div>
                </form>
                <div className='social-icons'>
                    <div className='social-icon'>
                        <TiSocialGooglePlus/>
                    </div>
                    <div className='social-icon'>
                        <FaFacebookF/>
                    </div>
                    <div className='social-icon'>
                        <FaTwitter/>
                    </div>
                    <div className='social-icon'>
                        <FaInstagram/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Subscribe
